const firebase = require('firebase');

// Required for side-effects
require('firebase/firestore');

const config = {
  apiKey: 'AIzaSyDgsQxSo5vfryT3q0waRF_Cg7Nq3cQwgTc',
  authDomain: 'lyonplates-f3f50.firebaseapp.com',
  databaseURL: 'https://lyonplates-f3f50.firebaseio.com',
  projectId: 'lyonplates-f3f50',
  storageBucket: 'lyonplates-f3f50.appspot.com',
  messagingSenderId: '570975230306',
};

export const firebaseApp = firebase.initializeApp(config);
export const db = firebase.firestore();
export const usersCollection = db.collection('users');
export const scripturePostsCollection = db.collection('scripturePosts');



// WEBPACK FOOTER //
// ./src/firebase.js